import React, { Component } from 'react';

class Order extends Component{
    constructor(props) {
        super(props);
        this.state = {
          error: null,
          isLoaded: false,
          orders: [],
          items: []
        };
      }
    componentDidMount() {
    //let access_token = sessionStorage.getItem("access_token");
    //let seller = sessionStorage.getItem("order_id");
    //let url = "https://api.mercadolibre.com/orders/search?" + order_id + "?access_token=" + access_token;
    fetch("./orders.json")
    .then(res => res.json())
    .then(
      (result) => {
        this.setState({
          isLoaded: true,
          orders: result.results
        });
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        this.setState({
          isLoaded: true,
          error
        });
      }
    )
    }
    render() {
        const { error, isLoaded, orders } = this.state;
        if (error) {
            return <div>Error: {error.message}</div>;
          } else if (!isLoaded) {
            return <div>Loading...</div>;
          } else {
        return (
            <div class="panel panel-default">
                <div class="panel-heading">Ventas</div>
            <div className="table">
            <thead>
            <tr>
                <th>id</th>
                <th>Item</th>
                <th>buyer id</th>
                <th>Comprandor</th>
                <th>Estado</th>
                </tr>
            </thead>
            <tbody>
          {orders.map((order) => (
            <tr>
            <th key={order.id}>{order.id}</th>
            <th key={order.order_items[0].item.title}>{order.order_items[0].item.title}</th>
            <th key={order.buyer}>{order.buyer.id}</th>
            <th key={order.buyer}>{order.buyer.nickname}</th>
            <th key={order.status}>{order.status}</th>
            </tr>
            ))}
            </tbody>
            </div>
            </div>
        );
      }
    }
}

export default Order;